export interface CmsProtectionStartSummaryPanelWhiteGoods {
  protectionStartSummaryPanelBodyWhiteGoods?: string;
  protectionStartSummaryPanelTitleWhiteGoods?: string;
}
